export default "__VITE_ASSET__BEETPfoz__"